import { render, staticRenderFns } from "./SubstituirCaixa2.vue?vue&type=template&id=53913e4f&scoped=true&"
import script from "./SubstituirCaixa2.vue?vue&type=script&lang=js&"
export * from "./SubstituirCaixa2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53913e4f",
  null
  
)

export default component.exports